import React from 'react'
import { Link } from 'gatsby'
import ProfileImage from '@/components/Feature/Candidatos/Ficha/Profileimage'
import dasherize from '@/util/dasherize'
import { ArrowRightIcon } from '@primer/octicons-react'
import PercentageBar from '../PercentageBar'

const candidateLink = (distrito, circunscripcion, nombre) => {
  if (distrito) {
    return `/diputados/distrito-${distrito}/${dasherize(nombre)}/`
  }
  if (circunscripcion) {
    return `/senadores/circunscripcion-${circunscripcion}/${dasherize(nombre)}/`
  }
  return `/presidentes/${dasherize(nombre)}/`
}

const PhotoCard = ({
  circunscripcion,
  cantidadDeVotos,
  distrito,
  fotoImage,
  letralista,
  lista,
  numerocandidato,
  nombre,
  partidoPolitico,
  twitterImage,
  porcentaje,
}) => {
  // cantidadDeVotos: 5124
  // distrito: 19
  // fotoImage: null
  // letralista: "AP"
  // lista: "Frente Social Cristiano"
  // nombre: "Sara Concha Smith"
  // numerocandidato: 84
  // partidoPolitico: "Partido Conservador Cristiano (PCC)"
  // porcentaje: 31
  // twitterImage: null

  const thousandSeparator = num => {
    if (num === null) return null
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
  }

  return (
    <nav className=" listas-home-block__list">
      <div className="listas-home-block__list-title">
        <h3 className="grid items-center grid-cols-12 gap-3 mb-2 font-sans text-xl leading-none text-left ">
          <Link
            className="col-span-2"
            to={candidateLink(distrito, circunscripcion, nombre)}>
            <ProfileImage
              nombre={nombre}
              twitterImage={twitterImage}
              fotoImage={fotoImage}
            />
          </Link>
          <Link
            className="col-span-9"
            to={candidateLink(distrito, circunscripcion, nombre)}>
            <div>
              <h3 className="text-xl leading-none text-left">
                <strong>{nombre}</strong>{' '}
                <span className="text-sm text-gray-800">
                  {letralista}
                  {numerocandidato}
                </span>
              </h3>
              {partidoPolitico ? (
                <p className="pb-0 text-sm text-left">{partidoPolitico}</p>
              ) : (
                <p className="pb-0 text-sm text-left">Independiente</p>
              )}
              <p className="pb-0 mb-2 text-base text-left">
                {thousandSeparator(cantidadDeVotos)} votos
              </p>
              <PercentageBar percentage={porcentaje} color="#059700" />
            </div>
          </Link>
          <Link
            className="col-span-1"
            to={candidateLink(distrito, circunscripcion, nombre)}>
            <ArrowRightIcon size={24} className="text-rojo" />
          </Link>
        </h3>
      </div>
    </nav>
  )
}

export default PhotoCard
